import _asyncToGenerator from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PaginationNumbers from "./PaginationNumbers.vue";
export default {
  name: "PaginationTable.vue",
  components: {
    PaginationNumbers: PaginationNumbers
  },
  data: function data() {
    return {
      data: [],
      page: 0,
      totalItems: 0,
      itemsPerPage: 20
    };
  },
  mounted: function mounted() {
    this.getData(this.page);
  },
  methods: {
    getData: function getData(page) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, _result$additional, _result$additional$pa, _result$additional2, _result$additional2$p;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.$vs.loading();

                _context.next = 4;
                return _this.fetchData(page + 1);

              case 4:
                result = _context.sent;

                if (result.data) {
                  _this.data = result.data;
                  _this.totalItems = (_result$additional = result.additional) === null || _result$additional === void 0 ? void 0 : (_result$additional$pa = _result$additional.paginator) === null || _result$additional$pa === void 0 ? void 0 : _result$additional$pa.total;
                  _this.itemsPerPage = (_result$additional2 = result.additional) === null || _result$additional2 === void 0 ? void 0 : (_result$additional2$p = _result$additional2.paginator) === null || _result$additional2$p === void 0 ? void 0 : _result$additional2$p.per_page;
                }

                _this.$vs.loading.close();

                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                _this.$vs.loading.close();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }))();
    },
    onChangedPage: function onChangedPage(page) {
      this.page = page;
      this.getData(page);
    },
    onClickItem: function onClickItem(item) {
      this.$emit("onClickItem", item);
    }
  },
  props: {
    fetchData: {
      required: true,
      type: Function
    },
    tableHeaders: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
};